import { RouterStore } from 'mobx-react-router'

export const routerStore = new RouterStore()

export { default as globalStore } from '../store/globalStore'
export { default as authStore } from '../store/authStore'
export { default as rightsStore } from './rightsStore'
export { default as collectionsStore } from './collectionsStore'
export { default as collectionTypesStore } from './collectionTypesStore'
export { default as companiesStore } from './companiesStore'
export { default as commonSettingsStore } from './commonSettingsStore'
export { default as couponTypesStore } from './couponTypesStore'
export { default as couponsStore } from './couponsStore'
export { default as doctorsStore } from './doctorsStore'
export { default as rightsParametersStore } from './rightsParametersStore'
export { default as insuranceCalculatorStore } from './insuranceCalculatorStore'
export { default as termsStore } from './termsStore'
export { default as termCollectionsStore } from './termCollectionsStore'
export { default as parametersStore } from './parametersStore'
export { default as paramGroupsStore } from './paramGroupsStore'
export { default as policiesStore } from './policiesStore'
export { default as policyCollectionsStore } from './policyCollectionsStore'
export { default as notifications } from './notifications'
export { default as inquiries } from './inquiries'
export { default as popupStore } from './popupStore'
export { default as productStore } from './productStore'
export { default as providerStore } from './providersStore'
export { default as purchaseStore } from './purchaseStore'

export { default as clinicsStore } from './clinicsStore'
export { default as clinicServicesStore } from './clinicServicesStore'
export { default as clientsStore } from './clientsStore'
export { default as drugsStore } from './drugsStore'
export { default as logsStore } from './logsStore'
export { default as citiesStore } from './citiesStore'
export { default as recordsStore } from './recordsStore'
export { default as categoriesStore } from './categoriesStore'
export { default as servicefieldsStore } from './servicefieldsStore'
export { default as specializationsStore } from './specializationsStore'
export { default as synonymsStore } from './synonymsStore'
export { default as servicesStore } from './servicesStore'
export { default as rightParamSetStore } from './rightParamSetStore'
export { default as regionsStore } from './regionsStore'
export { default as statisticsStore } from './statisticsStore'
export { default as subscriptionsStore } from './subscriptionsStore'
export { default as cancellationRequestStore } from './cancellationRequestStore'
export { default as roleStore } from './roleStore'
export { default as mentorCommissionStore } from './mentorCommissionStore'

// export { default as s3Store } from '../store-old/_DEL_s3Store/_DEL_index'
